"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParseTaskStatus = void 0;
const react_1 = require("react");
const workflow_core_1 = require("@sierralabs/workflow-core");
function useParseTaskStatus(status) {
    return (0, react_1.useMemo)(() => (0, workflow_core_1.parseTaskStatus)(status), [status]);
}
exports.useParseTaskStatus = useParseTaskStatus;
//# sourceMappingURL=useParseTaskStatus.js.map